module.exports = __webpack_public_path__ + "fonts/montserrat-light-webfont.1e8a7c1.woff";